"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSmsSendingEndpoint = getSmsSendingEndpoint;
exports.getVerifySmsEndpoint = getVerifySmsEndpoint;
exports.getOpenVerificationEndpoint = getOpenVerificationEndpoint;
exports.getChangeContactDetailsOnRegistrationEndpoint = getChangeContactDetailsOnRegistrationEndpoint;
function getSmsSendingEndpoint() {
    return "/sms/send";
}
function getVerifySmsEndpoint() {
    return "/customer/verify/sms";
}
function getOpenVerificationEndpoint() {
    return "/customer/verify/open-verification";
}
function getChangeContactDetailsOnRegistrationEndpoint(encryptedId) {
    return `/customer/verify/change-details-on-registration/${encryptedId}`;
}
//# sourceMappingURL=registration.js.map